import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface HeaderBannerState {
  content: ReactNode | null;
  setBanner: (content: ReactNode | null) => void;
}

const HeaderBannerContext = createContext<HeaderBannerState>({
  content: null,
  setBanner: () => {}
});

export const HeaderBannerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [content, setContent] = useState<ReactNode | null>(null);
  const setBanner = useCallback((node: ReactNode | null) => setContent(node), []);
  return (
    <HeaderBannerContext.Provider value={{ content, setBanner }}>
      {children}
    </HeaderBannerContext.Provider>
  );
};

export const useHeaderBanner = () => useContext(HeaderBannerContext);
